import React from 'react';
import Select, { selectType } from 'Components/Select';
import {Input, inputStyleClasses} from 'Components/Input';

const statuses = ['All', 'Approved', 'Incomplete', 'Deactivated', 'Pending'];

export default class FiltersSection extends React.Component {
  render() {
    const { handleSelectFilter, filterState, searchString, handleSearchStringInput } = this.props;

    return (
      <section className='list__utility-section  _margin_bottom_20 _margin_top_20'>
        <Input
          mainWrapperClassName='_width_450 _height_20 _margin_top_10'
          styleClass={inputStyleClasses.searchBarSmall}
          placeholder='Type here to search'
          maxLength={250}
          value={searchString}
          onChange={handleSearchStringInput}
        />
        <section className='list-scene__utility-section-filters-wrapper'>
          <div className='list-scene__utility-section-filters-header'>Filter</div>
          <Select
            label='by Status'
            type={selectType.listFilter}
            withoutSearch
            defaultItem={filterState.applicationStatus}
            placeholder='All'
            selectionList={statuses}
            handleSelect={handleSelectFilter('applicationStatus')}
          />
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/Details/ComponentList/FiltersSection.jsx